import { createSelector } from 'reselect';
import { NeoState } from '../Reducers.interface';
import { SearchEvent } from '../../Models/DTO/SearchEvent.model';
import { SearchCustomer } from '../../Models/DTO/SearchCustomer.model';
import { getInitials } from '../../Helpers/String.helper';
import { ISearchResults } from '~/Models/DTO/SearchResults.model';

const SelectCustomerSearch = (state: NeoState) => state.search.customers;

const SelectEventSearch = (state: NeoState) => state.search.events;

export const selectEventSearchResults = createSelector(
  SelectEventSearch,
  (events): ISearchResults[] =>
    events.map((item: SearchEvent) => ({ name: item.name, id: item.id })),
);

export const selectCustomersSearchResults = createSelector(
  SelectCustomerSearch,
  (customers): ISearchResults[] =>
    customers.map((item: SearchCustomer) => ({
      name: item.full_name,
      id: item.id,
      initials: getInitials(item.firstname, item.lastname),
      picture: item.image_id,
    })),
);

// we save the value of the input in a reducer so that we can access it in
// the results list and highlight the searchstring
export const selectSearchInput = (state: NeoState) => state.search.input;

export const selectBookableCustomerSearch = (state: NeoState) => state.search.bookableCustomers;
